
export default {
  props: {
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    titleTag: {
      type: String,
      default: 'h2'
    }
  },
  vessel: {
    title: {
      fontSize: '2xl',
      xl: {
        fontSize: '3xl'
      }
    }
  }
}
